import React from 'react';

import YoutubeSearchResult from './YoutubeSearchResult.react';

export default class YoutubeSearchResultList extends React.Component {
	static propTypes = {
		searchResultList: React.PropTypes.object.isRequired,
		onPick: React.PropTypes.func.isRequired
	};

	render() {
		const {searchResultList, onPick} = this.props;

		return (
			<div className="pixabay-search-result">
				{searchResultList.map((searchResult) => <YoutubeSearchResult key={searchResult.video_id} searchResult={searchResult} onPick={() => onPick(searchResult)} />)}
			</div>
		);
	}
}
